import React from "react";
import {useFormik} from "formik";
import * as yup from "yup";
import {useTranslation} from "react-i18next";

import MDLoadingButton from "../../../components/MDLoadingButton";

import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";


const CardPassword = ({userMutation}) => {
    const {t} = useTranslation(['user', "validation"]);

    const formik = useFormik({
        initialValues: {
            password: "password",
            passwordConfirmation: "",
        },
        validationSchema: yup.object({
            password: yup.string()
                .min(8, t('validation:minLength', {min: 8}))
                .required(t('validation:required')),
            passwordConfirmation: yup.string()
                .oneOf([yup.ref('password'), null], 'Passwords must match')
                .required(t('validation:required')),
        }),
        onSubmit: async (values) => {
            const {password} = values;
            await userMutation.mutate({password});

            // reset form
            formik.resetForm({password});
        }
    });

    const disableSave = !formik.dirty;

    return <Card>
        <MDBox py={2} px={2}>
            <MDTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                {t('cardPassword.title')}
            </MDTypography>
            <Stack spacing={2} mt={2} alignItems="center">
                <TextField name="password"
                           label={t('cardPassword.password')}
                           value={formik.values.password}
                           onChange={formik.handleChange}
                           error={formik.touched.password && Boolean(formik.errors.password)}
                           helperText={formik.touched.password && formik.errors.password}
                           variant="standard"
                           type="password"
                           fullWidth
                />
                <TextField name="passwordConfirmation"
                           label={t('cardPassword.passwordConfirmation')}
                           value={formik.values.passwordConfirmation}
                           onChange={formik.handleChange}
                           error={formik.touched.passwordConfirmation && Boolean(formik.errors.passwordConfirmation)}
                           helperText={formik.touched.passwordConfirmation && formik.errors.passwordConfirmation}
                           variant="standard"
                           type="password"
                           fullWidth
                />
                <MDBox>
                    <MDLoadingButton variant="contained"
                                     color="dark"
                                     loading={userMutation.isLoading}
                                     onClick={formik.handleSubmit}
                                     disabled={disableSave}>
                        {t('cardPassword.submit')}
                    </MDLoadingButton>
                </MDBox>
            </Stack>
        </MDBox>
    </Card>
}

export default CardPassword;
